import React,{useEffect, useRef, useState} from "react";

export const SearchTable = ({ tablaId, setValueFilter }) => {
    const [ verInput, setVerInput ] = useState();
    const inputBuscar = useRef(null);

    const getByFilter = async (value) =>{
        if (!tablaId) return
        const tabla = document.querySelector('#' + tablaId);
        const rows = tabla.children[1].children;
        const expresion = new RegExp(`${value}.*`, "i")

        for (let i = 0; i < rows.length; i++) {
            const cols = rows[i].children;
            let ocultar = true;

            for(let j = 0; j < cols.length; j++) {
                const value = cols[j].innerHTML;
                
                const booool = expresion.test(value);
                if (booool) {
                    ocultar = false;
                    break;
                }
            }
            rows[i].style.display = ocultar ? "none" : "";
        }
    }
    
    useEffect(() => {
        if (verInput) {
            inputBuscar.current.focus();
        }
    }, [verInput]);

    return (
    <>
        <div className="absolute right-[36px]" style={{zIndex:44}}>
            <div className="absolute w-[39px] active" > 
                <input ref={inputBuscar} onChange={e => {getByFilter(e.target.value); setValueFilter &&  setValueFilter(e.target.value)}} 
                    className={ ` ${verInput ? '': ' hidden ' } mt-[19px] text-white h-[32px]  
                    px-4 w-[180px] bg-zinc-800 text-[13px] focus:outline-none focus:ring-1
                     focus:ring-blue-500 caret-input absolute text-[#FFFFFF] right-[5px] 
                     bg-[#2f2f33] rounded-md border-[#171313] pl-[10px]" `} 
                    type="text" placeholder="Búsqueda" autoComplete="off"
                />
            </div>
            <div id="divBtnBuscar">
                <button
                    onClick={()=>setVerInput(!verInput)}
                    className="mt-[18px] absolute w-[36px] h-[34px] rounded-l-lg infoBusqueda
                    flex justify-center items-center bg-[#27272a] tooltipstered  text-[#FFFFFF]"
                >
                    <i className="fa fa-search " aria-hidden="true" />
                </button>
            </div>
        </div>
    </>
    );
}